import React from 'react'
import styles from './LoginModal.scss'
import googleBtn from './google-btn.png'
import { GoogleLogin } from 'react-google-login'
import { Modal } from 'common/styleguide/Modal'
import { CTA } from 'common/styleguide/CTA'
import { FormSubmitHack } from 'common/FormSubmitHack'
import { CircleSpinner } from 'common/spinners'
import { Icon } from 'common/Icon'
import { centeredText, errorMessage } from 'lib/styleguide/base.scss'
import fetchJSON from 'lib/fetchJSON'
import { Msg, fm } from 'lib/localization'
import p from 'prop-types'
import { FormattedMessage as T, defineMessages, injectIntl } from 'react-intl'

export const loginMessages = defineMessages({
  logIn: {
    id: 'loginMessages.logIn',
    defaultMessage: 'Log In'
  },
  email: {
    id: 'LoginModal.email',
    defaultMessage: 'Email Address'
  },
  password: {
    id: 'LoginModal.password',
    defaultMessage: 'Password'
  }
})

class _LoginModal extends React.PureComponent {
  static propTypes = {
    title: p.string,
    children: p.node,
    redirectTo: p.string
  }

  constructor (props) {
    super(props)
    // private instance id used for form IDs
    this._id = Math.random().toString(36).substring(5)
    this.state = {
      email: '',
      password: '',
      error: null,
      loginPending: false
    }
  }

  onEmailChange = e => this.setState({ email: e.target.value })

  onPasswordChange = e => this.setState({ password: e.target.value })

  handleApple = (e) => {
    e.preventDefault()
    const { redirectTo } = this.props

    fetchJSON('/sso/apple/web', Object.assign({
      method: 'POST'
    },
    redirectTo && { 'redirect_url': redirectTo }
    )).then(r => {
      window.location = r.sso.provider_url
    })
  }

  responseGoogle = (response) => {
    fetchJSON('/sso/google/callback', {
      identity_token: response.tokenId
    }).then(() => {
      window.location.reload()
    }).catch(() => {
      this.setState({
        error: <T id='LoginModal.unableToAuthenticate' defaultMessage='Unable to find your account. Please create an account or contact support.' />,
        loginPending: false
      })
    })
  }

  onSubmit = (e) => {
    e && e.preventDefault()
    const { redirectTo, beforeRefresh } = this.props
    const { email, password } = this.state
    if (!email || !password) {
      this.setState({
        error: <T id='LoginModal.missingEmailPass' defaultMessage='Please fill out the email and password fields.' />,
        loginPending: false
      })
      return
    }
    this.setState({ loginPending: true })
    fetchJSON('/login.json?apikey=x&version=3', { email, password })
      .then((res) => {
        const redirect = redirectTo || res.meta.redirect
        if (redirect) {
          window.location = redirect
        } else {
          if (beforeRefresh) beforeRefresh()
          window.location.reload(true)
        }
      })
      .catch(() => {
        this.setState({
          error: <T id='LoginModal.unableToLogIn' defaultMessage='Oops, we were unable to log you in. Please check your email and password and try again.' />,
          loginPending: false
        })
      })
  }

  render () {
    const { title, children, redirectTo, intl, ...props } = this.props
    const { email, password, error, loginPending } = this.state
    const _id = this._id
    const currentPath = redirectTo || (window.location.pathname + window.location.search + window.location.hash)
    const state = encodeURIComponent(JSON.stringify({ attempted_url: currentPath }))
    const fbCallbackURI = encodeURIComponent(`${window.location.origin}/create_facebook_session`)
    const clientId = window.rwgps.config.facebookAppId
    const fbAuthUrl = `https://www.facebook.com/v2.7/dialog/oauth?client_id=${clientId}&redirect_uri=${fbCallbackURI}&state=${state}`

    return (
      <Modal
        title={title ?? fm(intl, loginMessages.logIn)}
        subtitle={<T
          id='LoginModal.needAccount'
          defaultMessage='Need a Ride with GPS account? <a>Create an account</a>'
          values={{ a: (...c) => <a href={`/signup${redirectTo ? `?redirect=${encodeURIComponent(redirectTo)}` : ''}`}>{c}</a> }} />}
        {...props}>
        {children}
        {error && <p className={errorMessage}>{error}</p>}
        <form onSubmit={this.onSubmit}>
          <FormSubmitHack />
          <div>
            <label htmlFor={'email-' + _id}>
              <Msg m={loginMessages.email} />
            </label>
            <input className={styles.largeText} id={'email-' + _id} autoFocus type='email' value={email} onChange={this.onEmailChange} />
          </div>

          <div>
            <label htmlFor={'password-' + _id}>
              <Msg m={loginMessages.password} />
            </label>
            <input className={styles.largeText} id={'password-' + _id} type='password' value={password} onChange={this.onPasswordChange} />
          </div>
          <CTA button type='submit' disabled={loginPending} onClick={this.onSubmit}>
            {loginPending
              ? <CircleSpinner light size={12} />
              : <Msg m={loginMessages.logIn} />}
          </CTA>
        </form>
        <div className={styles.logInWith}>
          <T id='LoginModal.orWith' defaultMessage='or log in with' />:
        </div>
        <div className={styles.ssos}>
          <a href={fbAuthUrl} className={styles.fbBtn}><Icon i='fb-btn' size={42} /></a>
          <Icon i='apple-btn' size={42} onClick={this.handleApple} />
          <GoogleLogin
            clientId='210821712272-8d2eeje6vcj8tsrd7pjt8n4367g5jv0u.apps.googleusercontent.com'
            render={renderProps => (
              <img style={{ cursor: 'pointer' }} src={googleBtn} onClick={renderProps.onClick} />
            )}
            onSuccess={this.responseGoogle}
            onFailure={() => {}}
            cookiePolicy={'single_host_origin'}
          />
        </div>
        <p className={centeredText}>
          <a href='/users/forgot'>
            <T id='LoginModal.forgot' defaultMessage='Forgot password?' />
          </a>
        </p>
      </Modal>
    )
  }
}

export const LoginModal = injectIntl(_LoginModal)
